import service from './http'
/**
 * 用户中心相关接口
 */
// 我的课程
export function MyCourse(data) {
    return service({
      url: '/channelCustomerCourse/findList',
      method: 'get',
      params: data,
      headers: {
        Authorization: localStorage.getItem('shangke_token')
      }
    })
  }
